import {
  isChildMessage,
  WEBCHAT_MESSAGE_TYPE,
  type ChildMessage,
} from '@servicetitan/web-chat-types';

// Origin-validated message bridge. This check is a security control, not a
// display preference: without it, a page could load another tenant's
// iframe and hijack or inject into a live visitor's chat session.
export function handleMessageFromChild(
  validOrigins: string[],
  onMessage: (message: ChildMessage) => void,
): () => void {
  const listener = (event: MessageEvent): void => {
    if (!validOrigins.includes(event.origin)) {
      return;
    }
    const message = asChildMessage(event.data);
    if (message) {
      onMessage(message);
    }
  };

  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
}

// The shared isChildMessage guard rejects a ready payload when headerColors is
// present but malformed. That would drop the whole handshake and trip
// READY_TIMEOUT_MS even though the widget loaded. Colors are decoration; drop
// them and accept the ready itself. headerColors is the only field a ready
// carries, so what is left is a bare ready.
function asChildMessage(data: unknown): ChildMessage | undefined {
  if (isChildMessage(data)) {
    return data;
  }
  if (typeof data !== 'object' || data === null) {
    return undefined;
  }
  const payload = data as { type?: unknown };
  return payload.type === WEBCHAT_MESSAGE_TYPE.READY
    ? { type: WEBCHAT_MESSAGE_TYPE.READY }
    : undefined;
}
